// config.js
export const API_BASE_URL = 'https://yourseniorteam.com/api';





